import React from "react";
import PropTypes from "prop-types";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Card from "antd/lib/card";
import Tabs from "antd/lib/tabs";

const TabPane = Tabs.TabPane;

class LenderAnalysis extends React.Component {

    render() {
        return (
            <Row>
                <Col>
                    <Card title={"Summary"}>
                        <Tabs size={"small"} tabPosition={"left"}>
                            <TabPane key={"sanction-utilization"} name={"Sanction Utilization"}/>
                            <TabPane key={"pipeline-summary"} name={"Pipeline Summary"}/>
                        </Tabs>
                    </Card>
                </Col>
            </Row>
        );
    }


}

LenderAnalysis.propTypes = {
    route: PropTypes.object
};

export default LenderAnalysis;